/** @format */

import api from "./index";
import { Toast } from "vant";

// import localStorageUtil from '@/utils/localStorageUtil'

//因为同时发布多个异步请求的时候 执行的比较快的请求会把执行的比较慢的请求的“加载中”提示框去掉
//这里做个计数保证这一批的所有请求执行完之后再关闭 提示框
let indiTimes = 0;
let closeTimeout;
let toast;
/**
                                         * 根据响应规范封装的异步处理流程
                                         *
                                         *
                                         * @param {String} method api里的方法名
                                         * @param {Object} params 参数对象
                                         * @param {String} hideLoading（可选参数）是否隐藏loading，

                                        */
export const http = (method, params, { hideLoading = false } = {}) => {
    return new Promise((resolve, reject) => {
        if (!hideLoading && method != "simViewLogAdd") {
            toast = Toast.loading({
                forbidClick: true,
                duration: 0,
            });
            indiTimes++;
        }
        closeTimeout && clearTimeout(closeTimeout);
        closeTimeout = undefined;
        api[method](params)
            .then((response) => {
                const { status, data } = response;

                // 根据响应码决定清除toast的时机
                !hideLoading && indiTimes--;
                const delay = data.code === 0 ? 200 : 2000;
                if (!hideLoading && indiTimes < 1 && method != "simViewLogAdd") {
                    closeTimeout = setTimeout(() => {
                        toast.clear();
                    }, delay);
                }
                if (status === 200) {
                    resolve(data);
                } else {
                    reject(response);
                }
            })
            .catch((error) => {
                console.log("error", error);
                processError(hideLoading);
                reject(error);
            });
    });
};

//  处理网络错误、请求配置错误等
function processError(hideLoading) {
    !hideLoading && indiTimes--;
    if (indiTimes < 1) {
        closeTimeout = setTimeout(() => {
            toast.clear();
        }, 2000);
    }
}